import { Component } from '@angular/core';

@Component({
  selector: 'app-pfs-dashboard',
  templateUrl: './pfs-dashboard.component.html',
  styleUrls: ['./pfs-dashboard.component.css']
})
export class PfsDashboardComponent {

}
